var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Producao',{attrs:{"tipo-producao":"bar","titulo":"Bar","subtitulo":"Pedidos enviados para produção do bar","exibir-mesas-atalho":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }